module.exports = __webpack_public_path__ + "img/title.ef2bd2e0.png";